import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { truncateText } from "@jti/fe-common";
import { getCurrentMagentoClient } from "@jti/magento";
import { fetchCartItems, removeItem, useDispatch, useSelector } from "@jti/store";
import { Icon, PopoverButton, QuantityInput, toast, useTranslations } from "@jti/ui";
import InformationIcon from "@jti/ui/icons/information.svg";
import InformationIconBlack from "@jti/ui/icons/information-filled.svg";
import { getGiftItemsFromCart } from "../../../utils/getGiftItemsFromCart";
import styles from "./FreeGift.module.scss";
const maxTooltipLength = 130;
export const FreeGift = ({ name, image, parentItemId, parentItemSku, giftSku, hasReachedLimit, selectedFreeGifts, quantityAddedToCart, setSelectedFreeGiftQuantity, tooltip, }) => {
    const dispatch = useDispatch();
    const { __ } = useTranslations();
    const [isPending, setIsPending] = useState(false);
    const orderLimitEnabled = useSelector((state) => state.cart.storeConfig?.is_order_limit_enabled);
    const cartId = useSelector((state) => state.cart.id) ?? "";
    const productsInCart = useSelector((state) => state.cart.items);
    const count = selectedFreeGifts[parentItemId]?.[giftSku] || 0;
    const removeGiftItems = async (items, cartId) => {
        const removalPromises = items
            .filter((item) => item?.id)
            .map((item) => dispatch(removeItem({ cartId, itemId: item.id })));
        await Promise.all(removalPromises);
    };
    const handleGiftCountChange = async (upcomingValue) => {
        if (upcomingValue === count)
            return;
        setIsPending(true);
        const client = getCurrentMagentoClient();
        const giftItems = getGiftItemsFromCart(productsInCart, giftSku, parentItemId);
        try {
            await removeGiftItems(giftItems, cartId);
            if (upcomingValue > 0) {
                await client.addProductsToCart(cartId, [
                    {
                        productSku: parentItemSku,
                        giftSku,
                        quantity: upcomingValue,
                        parentGiftId: parentItemId,
                    },
                ]);
            }
            await dispatch(fetchCartItems(cartId));
            setSelectedFreeGiftQuantity({ parentGiftId: parentItemId, giftSku, quantity: upcomingValue });
        }
        catch (err) {
            toast.error(__("cart.checkout.free_gifts.error"));
            console.error("Error updating free gift quantity:", err);
            newrelic.noticeError(new Error(`Error updating free gift quantity: ${err}`));
        }
        finally {
            setIsPending(false);
        }
    };
    return (_jsx("div", { className: styles.container, children: _jsxs("div", { className: styles.content, children: [_jsxs("div", { className: styles.description, children: [image && _jsx("img", { "data-testid": "freeGiftImage", src: image.url, alt: image.label, className: styles.image }), _jsx("span", { "data-testid": "freeGiftName", className: styles.name, children: name }), tooltip && (_jsx("div", { className: styles.tooltip, children: _jsx(PopoverButton, { closedIcon: _jsx(Icon, { component: InformationIcon, width: "14px", height: "14px" }), openedIcon: _jsx(Icon, { component: InformationIconBlack, width: "14px", height: "14px" }), content: _jsx("span", { children: truncateText(tooltip, maxTooltipLength) }), helperClass: "hintBox", showCloseBtn: true, showHelpIcon: false, popperVariant: "small", isPopper: true }) }))] }), _jsx(QuantityInput, { value: quantityAddedToCart, canZero: true, disabled: false, disabledAdd: hasReachedLimit, hoverLimitDisplay: false, displayMessage: false, productLimitCurrency: "", quantityOrderLimit: { isLimit: 0, quantityLimit: 0 }, onChange: (value) => handleGiftCountChange(value), pending: isPending, orderLimitEnabled: orderLimitEnabled })] }) }));
};
//# sourceMappingURL=FreeGift.js.map